var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    { attrs: { name: "modal-create-complaint", width: 1000 } },
    [
      _c("div", [
        _c(
          "header",
          {
            staticClass:
              "modal-header py25 px65 h3 sans-serif weight-800 bg-cl-secondary"
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("Select the type of complaint")) +
                "\n      "
            ),
            _c(
              "i",
              {
                staticClass: "modal-close material-icons cl-bg-tertiary",
                attrs: { slot: "close" },
                on: { click: _vm.close },
                slot: "close"
              },
              [_vm._v("\n        close\n      ")]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "modal-content bg-cl-primary pt20 pb30 px65 cl-secondary"
          },
          [
            _c(
              "form",
              {
                attrs: { novalidate: "" },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.create($event)
                  }
                }
              },
              [
                _c("div", { staticClass: "row mb0" }, [
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-12 mb12 rma-type" },
                    _vm._l(_vm.typeOptions, function(type, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "col-md-12" },
                        [
                          _c("label", { staticClass: "radioStyled" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(type.label ? type.label : type.value) +
                                "\n                "
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.rmaType,
                                  expression: "rmaType"
                                }
                              ],
                              attrs: { type: "radio", name: "rma_type" },
                              domProps: {
                                value: type.value,
                                checked: _vm._q(_vm.rmaType, type.value)
                              },
                              on: {
                                change: [
                                  function($event) {
                                    _vm.rmaType = type.value
                                  },
                                  function($event) {
                                    _vm.$v.rmaType.$touch()
                                    _vm.rmaTypeChanged()
                                  }
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "checkmark" })
                          ])
                        ]
                      )
                    }),
                    0
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mb10" }, [
                  _c(
                    "div",
                    { staticClass: "col-xs-12" },
                    [
                      _c("cms-block-chunk", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.rmaType === "",
                            expression: "rmaType === ''"
                          }
                        ],
                        staticClass: "complaint_block",
                        attrs: {
                          identifier: "c_COMPLAINT_TEXT",
                          "default-value": "<p/>"
                        }
                      }),
                      _vm._v(" "),
                      _c("cms-block-chunk", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.rmaType === "Door To Door",
                            expression: "rmaType === 'Door To Door'"
                          }
                        ],
                        staticClass: "complaint_block",
                        attrs: {
                          identifier: "c_COMPLAINT_DOOR_2_DOOR",
                          "default-value": "<p/>"
                        }
                      }),
                      _vm._v(" "),
                      _c("cms-block-chunk", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.rmaType === "Zwrot",
                            expression: "rmaType === 'Zwrot'"
                          }
                        ],
                        staticClass: "complaint_block",
                        attrs: {
                          identifier: "c_COMPLAINT_RETURN",
                          "default-value": "<p/>"
                        }
                      }),
                      _vm._v(" "),
                      _c("cms-block-chunk", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.rmaType === "Klient Trzeci",
                            expression: "rmaType === 'Klient Trzeci'"
                          }
                        ],
                        staticClass: "complaint_block",
                        attrs: {
                          identifier: "c_COMPLAINT_PRINTE",
                          "default-value": "<p/>"
                        }
                      }),
                      _vm._v(" "),
                      _c("cms-block-chunk", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.rmaType === _vm.getHOME_AND_OFFICE_RMA(),
                            expression: "rmaType === getHOME_AND_OFFICE_RMA()"
                          }
                        ],
                        staticClass: "complaint_block",
                        attrs: {
                          identifier: "c_COMPLAINT_DOM_i_BIURO",
                          "default-value": "<p/>"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mb40" }, [
                  _c(
                    "div",
                    { staticClass: "col-xs-6" },
                    [
                      _c("Search", {
                        ref: "productsSearch",
                        staticClass: "brdr-1 brdr-cl-black",
                        staticStyle: { "border-radius": "24px" },
                        attrs: {
                          id: "products-search",
                          placeholder: _vm.$t("Find product ..."),
                          query: _vm.query,
                          results: _vm.filteredProducts,
                          "min-query-length": 3,
                          isSelectedQuery: _vm.isSelectedQuery
                        },
                        on: {
                          input: function($event) {
                            _vm.query = $event
                          },
                          selectItem: _vm.handleSelectItem
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-xs-6" },
                    [
                      _c(
                        "button-full",
                        {
                          attrs: {
                            type: "button",
                            disabled: !_vm.isValidPositionForm()
                          },
                          nativeOn: {
                            click: function($event) {
                              return _vm.addItem($event)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Add position")))]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row mb0" },
                  [
                    _c("base-input", {
                      staticClass: "col-xs-3",
                      staticStyle: { "min-height": "0px" },
                      attrs: {
                        type: "hidden",
                        name: "sku",
                        disabled: true,
                        placeholder: _vm.$t("SKU *")
                      },
                      on: {
                        blur: function($event) {
                          return _vm.$v.sku.$touch()
                        }
                      },
                      model: {
                        value: _vm.sku,
                        callback: function($$v) {
                          _vm.sku = $$v
                        },
                        expression: "sku"
                      }
                    }),
                    _vm._v(" "),
                    _c("base-input", {
                      staticClass: "col-xs-3",
                      staticStyle: { "min-height": "0px" },
                      attrs: {
                        type: "hidden",
                        name: "part_number",
                        disabled: true,
                        placeholder: _vm.$t("BP model")
                      },
                      on: {
                        blur: function($event) {
                          return _vm.$v.part_number.$touch()
                        }
                      },
                      model: {
                        value: _vm.part_number,
                        callback: function($$v) {
                          _vm.part_number = $$v
                        },
                        expression: "part_number"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.items.length > 0
                  ? _c("div", { staticClass: "row mb40 px15 pt10" }, [
                      _c(
                        "table",
                        {
                          staticClass: "brdr-cl-bg-secondary",
                          staticStyle: { width: "100%" }
                        },
                        [
                          _c(
                            "tbody",
                            _vm._l(_vm.items, function(item, index) {
                              return _c(
                                "tr",
                                {
                                  key: _vm.getItemKey(item),
                                  staticClass: "brdr-cl-bg-secondary"
                                },
                                [
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "complaint_item product--info"
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(index + 1) +
                                          ". " +
                                          _vm._s(_vm.$t("BP Model")) +
                                          ":\n                  " +
                                          _vm._s(item.part_number) +
                                          "\n                "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.rmaType === "Zwrot" ||
                                            _vm.rmaType === "service",
                                          expression:
                                            "rmaType === 'Zwrot' || rmaType === 'service'"
                                        }
                                      ],
                                      staticClass: "complaint_item"
                                    },
                                    [
                                      _c("base-input", {
                                        staticStyle: { "min-height": "44px" },
                                        attrs: {
                                          type: "text",
                                          name: "quantity",
                                          placeholder: _vm.$t("Quantity *")
                                        },
                                        on: {
                                          blur: function($event) {
                                            return _vm.$v.item.quantity.$touch()
                                          }
                                        },
                                        model: {
                                          value: item.quantity,
                                          callback: function($$v) {
                                            _vm.$set(item, "quantity", $$v)
                                          },
                                          expression: "item.quantity"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.rmaType === "Door To Door" ||
                                            _vm.rmaType === "Klient Trzeci",
                                          expression:
                                            "\n                    rmaType === 'Door To Door' || rmaType === 'Klient Trzeci'\n                  "
                                        }
                                      ],
                                      staticClass: "complaint_item"
                                    },
                                    [
                                      _c("base-input", {
                                        staticStyle: { "min-height": "44px" },
                                        attrs: {
                                          type: "text",
                                          name: "device",
                                          placeholder: _vm.$t("Printer *")
                                        },
                                        on: {
                                          blur: function($event) {
                                            return _vm.$v.item.device.$touch()
                                          }
                                        },
                                        model: {
                                          value: item.device,
                                          callback: function($$v) {
                                            _vm.$set(item, "device", $$v)
                                          },
                                          expression: "item.device"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.rmaType === "Zwrot",
                                          expression: "rmaType === 'Zwrot'"
                                        }
                                      ],
                                      staticClass: "complaint_item"
                                    },
                                    [
                                      _c("base-input", {
                                        staticStyle: { "min-height": "44px" },
                                        attrs: {
                                          type: "text",
                                          name: "invoice",
                                          placeholder: _vm.$t("Invoice *")
                                        },
                                        on: {
                                          blur: function($event) {
                                            return _vm.$v.item.invoice.$touch()
                                          }
                                        },
                                        model: {
                                          value: item.invoice,
                                          callback: function($$v) {
                                            _vm.$set(item, "invoice", $$v)
                                          },
                                          expression: "item.invoice"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.rmaType === "Door To Door" ||
                                            _vm.rmaType === "Klient Trzeci",
                                          expression:
                                            "\n                    rmaType === 'Door To Door' || rmaType === 'Klient Trzeci'\n                  "
                                        }
                                      ],
                                      staticClass: "complaint_item"
                                    },
                                    [
                                      _c("base-select", {
                                        staticStyle: { "min-height": "44px" },
                                        attrs: {
                                          name: "reason",
                                          options: _vm.reasonOptions,
                                          placeholder: _vm.$t("Reason *"),
                                          autocomplete: "off"
                                        },
                                        on: {
                                          blur: function($event) {
                                            return _vm.$v.item.reason.$touch()
                                          },
                                          change: function($event) {
                                            return _vm.$v.item.reason.$touch()
                                          }
                                        },
                                        model: {
                                          value: item.reason,
                                          callback: function($$v) {
                                            _vm.$set(item, "reason", $$v)
                                          },
                                          expression: "item.reason"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    { staticStyle: { "text-align": "right" } },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticStyle: {
                                            border: "2px solid #000000"
                                          },
                                          attrs: { type: "button" },
                                          on: {
                                            click: function($event) {
                                              return _vm.deleteItem(
                                                item.sku,
                                                index
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(_vm.$t("Remove")) +
                                              "\n                  "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.rmaType !== _vm.getHOME_AND_OFFICE_RMA(),
                        expression: "rmaType !== getHOME_AND_OFFICE_RMA()"
                      }
                    ],
                    staticClass: "row mb10"
                  },
                  [
                    _c("base-input", {
                      staticClass: "col-xs-12",
                      attrs: {
                        type: "text",
                        name: "companyName",
                        placeholder: _vm.$t("Company name")
                      },
                      on: {
                        blur: function($event) {
                          return _vm.$v.companyName.$touch()
                        }
                      },
                      model: {
                        value: _vm.companyName,
                        callback: function($$v) {
                          _vm.companyName = $$v
                        },
                        expression: "companyName"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row mb10" },
                  [
                    _c("base-input", {
                      staticClass: "col-xs-6",
                      attrs: {
                        type: "text",
                        name: "firstName",
                        placeholder: _vm.$t("First name *"),
                        validations: [
                          {
                            condition:
                              !_vm.$v.firstName.required &&
                              _vm.$v.firstName.$error,
                            text: _vm.$t("Field is required.")
                          }
                        ]
                      },
                      on: {
                        blur: function($event) {
                          return _vm.$v.firstName.$touch()
                        }
                      },
                      model: {
                        value: _vm.firstName,
                        callback: function($$v) {
                          _vm.firstName = $$v
                        },
                        expression: "firstName"
                      }
                    }),
                    _vm._v(" "),
                    _c("base-input", {
                      staticClass: "col-xs-6",
                      attrs: {
                        type: "text",
                        name: "lastName",
                        placeholder: _vm.$t("Last name *"),
                        validations: [
                          {
                            condition:
                              !_vm.$v.lastName.required &&
                              _vm.$v.lastName.$error,
                            text: _vm.$t("Field is required.")
                          }
                        ]
                      },
                      on: {
                        blur: function($event) {
                          return _vm.$v.lastName.$touch()
                        }
                      },
                      model: {
                        value: _vm.lastName,
                        callback: function($$v) {
                          _vm.lastName = $$v
                        },
                        expression: "lastName"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row mb10" },
                  [
                    _c("base-input", {
                      staticClass: "col-xs-6",
                      attrs: {
                        type: "text",
                        name: "street",
                        placeholder: _vm.$t("Street name *"),
                        validations: [
                          {
                            condition:
                              !_vm.$v.street.required && _vm.$v.street.$error,
                            text: _vm.$t("Field is required.")
                          }
                        ]
                      },
                      on: {
                        blur: function($event) {
                          return _vm.$v.street.$touch()
                        }
                      },
                      model: {
                        value: _vm.street,
                        callback: function($$v) {
                          _vm.street = $$v
                        },
                        expression: "street"
                      }
                    }),
                    _vm._v(" "),
                    _c("base-input", {
                      staticClass: "col-xs-3",
                      attrs: {
                        type: "text",
                        name: "house",
                        placeholder: _vm.$t("House *"),
                        validations: [
                          {
                            condition:
                              !_vm.$v.house.required && _vm.$v.house.$error,
                            text: _vm.$t("Field is required.")
                          }
                        ]
                      },
                      on: {
                        blur: function($event) {
                          return _vm.$v.house.$touch()
                        }
                      },
                      model: {
                        value: _vm.house,
                        callback: function($$v) {
                          _vm.house = $$v
                        },
                        expression: "house"
                      }
                    }),
                    _vm._v(" "),
                    _c("base-input", {
                      staticClass: "col-xs-3",
                      attrs: {
                        type: "text",
                        name: "flat",
                        placeholder: _vm.$t("Flat")
                      },
                      on: {
                        blur: function($event) {
                          return _vm.$v.flat.$touch()
                        }
                      },
                      model: {
                        value: _vm.flat,
                        callback: function($$v) {
                          _vm.flat = $$v
                        },
                        expression: "flat"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row mb10" },
                  [
                    _c("base-input", {
                      staticClass: "col-xs-6",
                      attrs: {
                        type: "text",
                        name: "city",
                        placeholder: _vm.$t("City *"),
                        validations: [
                          {
                            condition:
                              !_vm.$v.city.required && _vm.$v.city.$error,
                            text: _vm.$t("Field is required.")
                          }
                        ]
                      },
                      on: {
                        blur: function($event) {
                          return _vm.$v.city.$touch()
                        }
                      },
                      model: {
                        value: _vm.city,
                        callback: function($$v) {
                          _vm.city = $$v
                        },
                        expression: "city"
                      }
                    }),
                    _vm._v(" "),
                    _c("base-input", {
                      staticClass: "col-xs-3",
                      attrs: {
                        type: "text",
                        name: "postcode",
                        placeholder: _vm.$t("Postcode *"),
                        validations: [
                          {
                            condition:
                              !_vm.$v.postcode.required &&
                              _vm.$v.postcode.$error,
                            text: _vm.$t("Field is required.")
                          }
                        ]
                      },
                      on: {
                        blur: function($event) {
                          return _vm.$v.postcode.$touch()
                        }
                      },
                      model: {
                        value: _vm.postcode,
                        callback: function($$v) {
                          _vm.postcode = $$v
                        },
                        expression: "postcode"
                      }
                    }),
                    _vm._v(" "),
                    _c("base-input", {
                      staticClass: "col-xs-3",
                      attrs: {
                        type: "text",
                        name: "phone",
                        placeholder: _vm.$t("Phone *"),
                        validations: [
                          {
                            condition:
                              !_vm.$v.phone.required && _vm.$v.phone.$error,
                            text: _vm.$t("Field is required.")
                          }
                        ]
                      },
                      on: {
                        blur: function($event) {
                          return _vm.$v.phone.$touch()
                        }
                      },
                      model: {
                        value: _vm.phone,
                        callback: function($$v) {
                          _vm.phone = $$v
                        },
                        expression: "phone"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.rmaType === _vm.getHOME_AND_OFFICE_RMA(),
                        expression: "rmaType === getHOME_AND_OFFICE_RMA()"
                      }
                    ],
                    staticClass: "row mb10"
                  },
                  [
                    _c("base-input", {
                      staticClass: "col-xs-6",
                      attrs: {
                        type: "text",
                        name: "invoiceNumber",
                        placeholder: _vm.$t("Invoice number *"),
                        validations: [
                          {
                            condition:
                              !_vm.$v.invoiceNumber.required &&
                              _vm.$v.invoiceNumber.$error,
                            text: _vm.$t("Field is required.")
                          }
                        ]
                      },
                      on: {
                        blur: function($event) {
                          return _vm.$v.invoiceNumber.$touch()
                        }
                      },
                      model: {
                        value: _vm.invoiceNumber,
                        callback: function($$v) {
                          _vm.invoiceNumber = $$v
                        },
                        expression: "invoiceNumber"
                      }
                    }),
                    _vm._v(" "),
                    _c("base-input", {
                      staticClass: "col-xs-6",
                      attrs: {
                        type: "text",
                        name: "email",
                        placeholder: _vm.$t("Email *"),
                        validations: [
                          {
                            condition:
                              !_vm.$v.email.required && _vm.$v.email.$error,
                            text: _vm.$t("Field is required.")
                          }
                        ]
                      },
                      on: {
                        blur: function($event) {
                          return _vm.$v.email.$touch()
                        }
                      },
                      model: {
                        value: _vm.email,
                        callback: function($$v) {
                          _vm.email = $$v
                        },
                        expression: "email"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.rmaType !== _vm.getHOME_AND_OFFICE_RMA(),
                        expression: "rmaType !== getHOME_AND_OFFICE_RMA()"
                      }
                    ],
                    staticClass: "row mb10"
                  },
                  [
                    _c("base-input", {
                      staticClass: "col-xs-12",
                      attrs: {
                        type: "text",
                        name: "description",
                        placeholder: _vm.$t("Description")
                      },
                      model: {
                        value: _vm.description,
                        callback: function($$v) {
                          _vm.description = $$v
                        },
                        expression: "description"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.rmaType === _vm.getHOME_AND_OFFICE_RMA(),
                        expression: "rmaType === getHOME_AND_OFFICE_RMA()"
                      }
                    ],
                    staticClass: "row mb10"
                  },
                  [
                    _c("base-input", {
                      staticClass: "col-xs-12",
                      attrs: {
                        type: "text",
                        name: "description",
                        placeholder: _vm.$t("Description of the notification")
                      },
                      model: {
                        value: _vm.description,
                        callback: function($$v) {
                          _vm.description = $$v
                        },
                        expression: "description"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "row mb10" }, [
                  _c("span", { staticClass: "fs-medium lh25" }, [
                    _vm._v(_vm._s(_vm.notification))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mb10" }, [
                  _c("div", { staticClass: "col-xs-6 col-sm-6" }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-xs-6 col-sm-6" },
                    [
                      _c(
                        "button-full",
                        {
                          staticClass: "mb20",
                          attrs: {
                            type: "submit",
                            disabled: !_vm.isValidForm()
                          }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("Create complaint")) +
                              "\n            "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              ]
            )
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }